import {IWidget} from "@/views/editor/widget";
import {Component, h} from "vue";
import {AEditor} from "@/views/editor/service/editor";
import {noPic} from "@/lib/util";
import SkuPddDpl from "@/views/editor/widget/sku/SkuPddDpl.vue";
import SkuPddCtl from "@/views/editor/widget/sku/SkuPddCtl.vue";

export interface ISkuPddMeta {
    // 逼单话术
    closing_scripts: {
        title: string
        style: 'red' | 'green'
    }[],
    box: {
        available: boolean,
        title: string
        sub_title: string
    },
    product: {
        pre_price: string
        is_show_tag: boolean
        // 卖点
        selling_point: string
    },
    button: {
        text: string
        is_show_original_price: boolean
    }
}

export class WidgetSkuPdd implements IWidget<ISkuPddMeta> {

    name = '拼多多样式';
    thumbnail = noPic;
    readonly meta: ISkuPddMeta

    constructor(public editor: AEditor, meta: unknown) {
        this.meta = meta as ISkuPddMeta;
    }

    controller(): Component {
        return SkuPddCtl;
    }

    defaultMeta(): ISkuPddMeta {
        return {
            box: {available: true, sub_title: "节日大促 限时直降", title: "大促优惠"},
            button: {is_show_original_price: true, text: "现在抢，仅"},
            product: {is_show_tag: true, pre_price: "", selling_point: "本店畅销第1"},
            closing_scripts: []
        };
    }

    display(): Component {
        return SkuPddDpl;
    }
}